/**
 * Deals API
 */
import apiClient from './index'
import type {
  ApiResponse,
  PaginatedResponse,
  PaginationParams,
  Deal,
  DealCreateData,
  DealUpdateData,
  DealFilters,
  DealStage,
  PipelineSummary,
} from '@/types'

export const dealsApi = {
  /**
   * List deals with filtering and pagination
   */
  async list(params?: PaginationParams & DealFilters): Promise<PaginatedResponse<Deal>> {
    const response = await apiClient.get<PaginatedResponse<Deal>>('/deals', { params })
    return response.data
  },

  /**
   * Get deal by ID
   */
  async get(id: string): Promise<Deal> {
    const response = await apiClient.get<ApiResponse<Deal>>(`/deals/${id}`)
    return response.data.data
  },

  /**
   * Create a new deal
   */
  async create(data: DealCreateData): Promise<Deal> {
    const response = await apiClient.post<ApiResponse<Deal>>('/deals', data)
    return response.data.data
  },

  /**
   * Update a deal
   */
  async update(id: string, data: DealUpdateData): Promise<Deal> {
    const response = await apiClient.put<ApiResponse<Deal>>(`/deals/${id}`, data)
    return response.data.data
  },

  /**
   * Delete a deal
   */
  async delete(id: string): Promise<void> {
    await apiClient.delete(`/deals/${id}`)
  },

  /**
   * Update deal stage
   */
  async updateStage(id: string, stage: DealStage, lostReason?: string): Promise<Deal> {
    const response = await apiClient.put<ApiResponse<Deal>>(`/deals/${id}/stage`, {
      stage,
      lost_reason: lostReason,
    })
    return response.data.data
  },

  /**
   * Get pipeline summary
   */
  async getPipelineSummary(): Promise<PipelineSummary[]> {
    const response = await apiClient.get<ApiResponse<PipelineSummary[]>>('/deals/pipeline')
    return response.data.data
  },
}
